module.exports = __webpack_public_path__ + "img/contract.0bba723a.svg";